import React, { useState } from 'react';
import { Button, Popup } from 'semantic-ui-react';
import TimDataSearchModal from './TimDataSearchModal';
import { DesignSystem } from '../../styles/designSystem';

export interface FloatingTimDataButtonProps {
  /** Quando true, não aplica posicionamento fixo (uso dentro de um cluster de FABs). */
  embedded?: boolean;
}

/**
 * Botão flutuante global "Consultar dados TIM por CNPJ" — segue exatamente o padrão visual
 * de `FloatingSimulationButton`, com gradiente próprio para diferenciar dos demais FABs.
 * Ver ideias/consulta-dados-tim-cnpj-renegociacao.md secção 5.5.
 */
const FloatingTimDataButton: React.FC<FloatingTimDataButtonProps> = ({ embedded = false }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const shellStyle: React.CSSProperties = embedded
    ? { position: 'relative', zIndex: 1000, display: 'inline-block' }
    : {
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 1000,
      };

  return (
    <>
      <div style={shellStyle}>
        <Popup
          content="Consultar dados TIM por CNPJ"
          position={embedded ? 'right center' : 'left center'}
          trigger={
            <Button
              circular
              size="large"
              icon="database"
              onClick={() => setIsModalOpen(true)}
              aria-label="Consultar dados TIM por CNPJ"
              style={{
                width: '60px',
                height: '60px',
                fontSize: '24px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                background: DesignSystem.colors.primary.gradient,
                color: DesignSystem.colors.neutral.black,
                border: 'none',
                transition: 'all 0.3s ease',
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
              }}
              onMouseEnter={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.currentTarget.style.transform = 'scale(1.1)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.25)';
              }}
              onMouseLeave={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
              }}
            />
          }
        />
      </div>

      {isModalOpen && <TimDataSearchModal open={isModalOpen} onClose={() => setIsModalOpen(false)} />}
    </>
  );
};

export default FloatingTimDataButton;
